import { render, staticRenderFns } from "./DashboardComponents.vue?vue&type=template&id=05c4d592&v-on-clickaway=cancel&"
import script from "./DashboardComponents.vue?vue&type=script&lang=ts&"
export * from "./DashboardComponents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports